import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';

const removeAccessoriesForSelectedEntity = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (selectedEntity) {
    const existingAccessories = coreApi.entities.getDescendantsWithOneOfProductTypes(
      selectedEntity,
      [
        ProductType.SMASTAD_BENCH_PAD,
        ProductType.SMASTAD_BOX,
        ProductType.SMASTAD_HANGING_STORAGE_CASE,
        ProductType.SMASTAD_MIRROR,
        ProductType.SMASTAD_HOOK_CLIP,
        ProductType.SMASTAD_LABEL_HOLDER
      ]
    );

    if (existingAccessories.length > 0) {
      coreApi.entities.deleteMultiple(existingAccessories);
    }
  }
};

export default removeAccessoriesForSelectedEntity;
